/**
 * Merchant-facing Redo product groupings used by the integrations catalog and
 * status RPCs. Coarser than billing's RedoInternalProduct by design.
 */
export const RedoProduct = {
  RETURNS: "returns",
  SUPPORT: "support",
  OMS: "oms",
  MARKETING: "marketing",
  ORDER_TRACKING: "order-tracking",
  CUSTOMER_ACCOUNTS: "customer-accounts",
  CONVERSION: "conversion",
  COVERAGE: "coverage",
} as const;
export type RedoProduct = (typeof RedoProduct)[keyof typeof RedoProduct];

export const PRODUCT_LABELS: Record<RedoProduct, string> = {
  [RedoProduct.RETURNS]: "Returns",
  [RedoProduct.SUPPORT]: "Support",
  [RedoProduct.OMS]: "Order management",
  [RedoProduct.MARKETING]: "Marketing",
  [RedoProduct.ORDER_TRACKING]: "Order tracking",
  [RedoProduct.CUSTOMER_ACCOUNTS]: "Customer accounts",
  [RedoProduct.CONVERSION]: "Conversion",
  [RedoProduct.COVERAGE]: "Coverage",
};
